module.exports = __webpack_public_path__ + "img/secundaria.091e15b9.svg";